export default __webpack_public_path__ + "static/media/hrc-logo.42c08d03.png";